export const message = {
  saveApisSuccess: 'Apis successfully saved',
  publishApisSuccess: 'Apis successfully published'
}